import { useParams } from "react-router";
import { useRelationshipsRelationshipShowQuery } from "@/services/backend/relationships/api/service";
import { SeriesCard } from "@/routes/customers/[customerId]/relationships/[relationshipId]/commitments/[commitmentId]/_components/series-card";

export function SeriesRoute() {
  const { relationshipId, commitmentId } = useParams();

  const { data: relationship } = useRelationshipsRelationshipShowQuery({
    id: relationshipId!,
  });

  const commitment = relationship?.commitments.find(
    (c) => c.id === commitmentId,
  );

  // If relationship or commitment do not exist, the CommitmentRoute will
  // catch it.

  return <SeriesCard relationship={relationship!} commitment={commitment!} />;
}
